package editor.structure

import common.dto.Direction
import common.dto.ElementType
import ext.asQuaternion
import three.js.Euler
import three.js.Quaternion
import kotlin.math.PI

/**
 * A structure is a list of elements that can be loaded into the editor and persisted in json format/the database.
 */
typealias Structure = List<StructureElement>

/**
 * A changeable structure.
 */
typealias MutableStructure = MutableList<StructureElement>

// first look up, then rotate around z axis by 90 degrees
private val quaternionTest = Direction.UP.quaternion.asQuaternion().multiply(Quaternion().setFromEuler(Euler(z = PI / 2)))

val defaultStructure: Structure = listOf(
    StructureElement(ElementType.Brixi),
//    StructureElement(ElementType.Twister, pos = Vec3d(x = -16.0), direction = Direction.LEFT),
//    StructureElement(ElementType.Twister, pos = Vec3d(y = 16.0), direction = Direction.UP),
//    StructureElement(ElementType.`2x3`, pos = Vec3d(z = -16.0), direction = Direction.FORWARD),
//    StructureElement(ElementType.`2x3`, pos = Vec3d(y = -16.0), rot = quaternionTest.asQuat()),
//    StructureElement(ElementType.`2x3`, pos = Vec3d(z = 16.0)/*, direction = Direction.BACKWARD*/),
//    StructureElement(ElementType.`2x3`, pos = Vec3d(x = 100.0, y = 90.0), euler = Vec3d(x = PI / 4, y = PI / 4)),
//    StructureElement(ElementType.Brixi, pos = Vec3d(y = 150.0), euler = Vec3d(x = PI / 4, z = PI / 2)),
)

